import Vue from 'vue';
import App from './App.vue';

// 引入ElementUI的js和css
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// 配置ElementUI
Vue.use(ElementUI)
// import VueRouter from 'vue-router';
import router from './router';

import { Loading } from "element-ui";
Vue.prototype.$loading = Loading.service;



import 'lib-flexible';
import less from 'less';
import './assets/css/publiccss.css';
Vue.config.productionTip = false;
import VideoPlayer from 'vue-video-player';

require('video.js/dist/video-js.css');
require('vue-video-player/src/custom-theme.css');
Vue.use(VideoPlayer);
Vue.use(less);

import api from './config/common.js';
Vue.prototype.$api = api

import VueResource from 'vue-resource' //引入
Vue.use(VueResource) //使用

import plugins from './plugins/modal'

Vue.use(plugins) 
/* import loading from './components/loading'
Vue.use(loading) */

import JSEncrypt from 'jsencrypt'
//vue项目中使用RSA加密 解密
Vue.prototype.$getRsaCode = function(str) { // 注册加密方法
	const encryptStr = new JSEncrypt()
	const pubKey =
		`MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDMXFAtzFH8O2O9KN4vApqU0Y0lbAyWzMVs1Q0o9tomClE47nwtE82h+kdJpvto6RBtNQIywywt/NlFdJhnFw/Oo4d7EqkT9C1hgeS8L2rgMDeum5S90xb0VMlhUMvzPRqjA8yQ8fBdAkNfu3YrlVYmTCKrKvkqC9iL14Sh557atQIDAQAB`
	encryptStr.setPublicKey(pubKey) // 设置 加密公钥
	const data = encryptStr.encrypt(str.toString()) // 进行加密
	return data
}


Vue.prototype.$getRsaDeCode = function(str) { // 解密
	var decrypt = new JSEncrypt()
	const pubKeyPrivate = `-----BEGIN RSA PRIVATE KEY-----  -----END RSA PRIVATE KEY-----` // ES6 模板字符串 引用 rsa 公钥
	decrypt.setPrivateKey(pubKeyPrivate) //解密公钥
	var decryptMsg = decrypt.decrypt(str.toString()) //解密
	return decryptMsg
}

router.beforeEach((to, from, next) => {
	// console.log(to)
	// 方法1：通过在路由元信息中添加登陆验证字段来实现进入某个页面时是否需要验证登录
	if (to.meta.requireAuth) { // 判断路由元信息中是否添加登陆验证字段
		// 判断 sessionStorage 中是否有登陆信息，如果已经有登陆信息，则放行
		if (localStorage.getItem('token')) { //
			next();
		} else {
			localStorage.clear();
			next({
				path: '/user/login'
			});
			return;
		}
	} else {
		next();
	}
})



new Vue({
	router,
	render: h => h(App),
}).$mount('#app');